export default __webpack_public_path__ + "static/media/gallery-11-1.50bb89b5.webp";